var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classList},[_vm._v("\n  © 2018-2022 HIPAAMATE, LLC. All Rights Reserved.\n")])}
var staticRenderFns = []

export { render, staticRenderFns }